import axios from "axios";
import { API_BASE } from "@/lib/api";

// Dedicated client for the customer portal. It must NOT send the staff token
// (jt_token); it uses its own portal_token (Bearer) plus the httpOnly cookie.
export const portalApi = axios.create({ baseURL: API_BASE, withCredentials: true });

portalApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("portal_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  // Tell the backend which brand/domain the visitor is on, so shipments + bookings
  // are scoped (and stamped) to that company (multi-brand by host).
  try { config.headers["X-Brand-Host"] = window.location.hostname; } catch { /* SSR */ }
  return config;
});
